import { render, staticRenderFns } from "./FormDrawer.vue?vue&type=template&id=5ff3db12&scoped=true"
import script from "./FormDrawer.vue?vue&type=script&lang=js"
export * from "./FormDrawer.vue?vue&type=script&lang=js"
import style0 from "./FormDrawer.vue?vue&type=style&index=0&id=5ff3db12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff3db12",
  null
  
)

export default component.exports